import React from 'react';
import PropTypes from 'prop-types';
import {Helmet} from 'react-helmet-async';

import {productUrl, webappURL} from '../../util/url';

function getProductCategory(product) {
    return [product.category, product.sub_category]
        .filter(Boolean)
        .join(' > ');
}

/**
 * Open Graph metadata component for a product.
 * @param product a product for which to generate metadata
 * @param title meta title
 * @param hostname
 * @return {*}
 * @constructor
 */
export default function ProductOpenGraph({ product, title, hostname }) {
    const productCategory = getProductCategory(product);

    return (
        <Helmet>
            {/* Cf schema at https://developers.facebook.com/docs/payments/product/,
              * https://developers.facebook.com/docs/marketing-api/catalog-setup/update-options/#og-required-tags and
              * https://webcode.tools/open-graph-generator/product-item
              */}
            <meta property="fb:app_id" content="330702484245822" />
            <meta property="og:site_name" content="FruitsFamily" />
            <meta property="og:type" content="product.item" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={product.description} />
            <meta property="og:url" content={webappURL(hostname) + productUrl(product)} />
            {(product?.resizedBigImages?.[0] ?? product?.resizedSmallImages?.[0]) && <meta property="og:image" content={product?.resizedBigImages?.[0] ?? product?.resizedSmallImages?.[0]}/>}
            {product.brand && <meta property="product:brand" content={product.brand} />}
            {productCategory && <meta property="product:category" content={productCategory} />}
            <meta property="product:availability" content={product.status === 'sold' ? 'out of stock' : 'in stock'} />
            {product.condition && (
                <meta property="product:condition" content={product.condition === 'NEW' ? 'new' : 'used'} />
            )}
            {product.gender && <meta property="product:gender" content={product.gender} />}
            <meta property="product:price:amount"  content={product.price} />
            <meta property="product:price:currency" content="KRW" />
            <meta property="product:retailer_item_id" content={product.id} />
        </Helmet>
    );
}
ProductOpenGraph.propTypes = {
    product: PropTypes.shape({
        id:  PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        brand: PropTypes.string,
        category: PropTypes.string,
        sub_category: PropTypes.string,
        price: PropTypes.number.isRequired,
        status: PropTypes.oneOf(['selling', 'sold']).isRequired,
        condition: PropTypes.string,
        gender: PropTypes.string,
        resizedBigImages: PropTypes.arrayOf(PropTypes.string).isRequired,
        resizedSmallImages: PropTypes.arrayOf(PropTypes.string).isRequired
    }).isRequired,
    title: PropTypes.string.isRequired,
    hostname: PropTypes.string.isRequired,
};
